import { convertToHexColor, getReadableTextColor } from '@libs/store';
import { AppointmentStatusColorV2 } from '@ffd/api-client';

export function getStatusColorHex(statusColor?: AppointmentStatusColorV2 | null): string | null {
  if (!statusColor) {
    return null;
  }
  return convertToHexColor(statusColor);
}

export function getStatusTextColor(statusColor?: AppointmentStatusColorV2 | null): string {
  const statusColorHex = getStatusColorHex(statusColor);
  if (!statusColorHex) {
    return '#000000';
  }
  return getReadableTextColor(statusColorHex);
}

export function getStatusAbbreviation(statusColor?: AppointmentStatusColorV2 | null): string {
  return statusColor?.statusCode || '';
}
